/** Shared pending-request counter for global API loading UI. */
let pending = 0;
const listeners = new Set();

function notify() {
  const busy = pending > 0;
  listeners.forEach((fn) => {
    try {
      fn(busy, pending);
    } catch (_) {
      /* ignore listener errors */
    }
  });
}

export function startLoading() {
  pending += 1;
  notify();
}

export function stopLoading() {
  pending = Math.max(0, pending - 1);
  notify();
}

export function resetLoading() {
  pending = 0;
  notify();
}

export function isLoadingBusy() {
  return pending > 0;
}

/** @returns {() => void} unsubscribe */
export function subscribeLoading(listener) {
  listeners.add(listener);
  listener(pending > 0, pending);
  return () => listeners.delete(listener);
}
